<template>
  <router-view />
  <ErrorDialog />
</template>

<script setup lang="ts">
import ErrorDialog from "./components/ui/ErrorDialog.vue"
</script>
